import { useUI } from 'ctx/UIContext'
import { classNames } from 'lib/misc'
import { Link } from 'react-router-dom'

type Props = {
  className?: string
}

const LogoRenderer = ({ className }: Props) => {
  const { whiteLabelData } = useUI()

  const getHomeLink = () => {
    switch (whiteLabelData.wlabel) {
      case 'arinasfilmmaker':
        return {
          link: 'https://arinasfilmmaker.com',
          isExternal: true,
        }
      default:
        return {
          link: '/',
          isExternal: false,
        }
    }
  }

  return getHomeLink().isExternal ? (
    <a
      href={getHomeLink().link}
      target='_blank'
      rel='noopener noreferrer'
      className={classNames(className ?? '')}
    >
      <img
        src={whiteLabelData.logo ?? '/assets/whitelabel-logo.png'}
        alt=''
        className='inline-block h-12 mr-4'
      />
    </a>
  ) : (
    <Link to={getHomeLink().link} className={classNames(className ?? '')}>
      <img
        src={whiteLabelData.logo ?? '/assets/whitelabel-logo.png'}
        alt=''
        className='inline-block h-12 mr-4'
      />
    </Link>
  )
}

export default LogoRenderer
